import { HGetKeyEnums } from "@rf-helper/generat-enums-from-keys";
import { SchemaItemGeneric } from "@rf/schemas/item-generic.shema";
import { array, boolean, InferType, mixed, object, string } from "@yup";
import featureIndicators from "../../model/feature-indicators";
const checkIfRequired = (id: number | null, types: number[]) => {
  return id ? types.includes(id) : true;
};
// Helper functions
// @ts-ignore
const getFromContextTypePropertyId = (elCtx: any, types: number[]) => {
  const ctx = elCtx?.from?.[2];
  if (!ctx) return false;
  const id = ctx?.value?.type_property[0]?.id || null;
  return checkIfRequired(id, types);
};

const checkIfRequiredLevel = function (ctx: any) {
  return getFromContextTypePropertyId(ctx, featureIndicators.projectLevelFloor);
};

const checkIfRequiredBedroom = function (ctx: any) {
  return getFromContextTypePropertyId(ctx, featureIndicators.projectBedrooms);
};

const checkIfRequiredBathRooms = function (ctx: any) {
  return getFromContextTypePropertyId(ctx, featureIndicators.projectBathrooms);
};

const checkIfRequiredBathParking = function (ctx: any) {
  return getFromContextTypePropertyId(ctx, featureIndicators.parkingSpots);
};

const checkIfRequiredLands = function (ctx: any) {
  return getFromContextTypePropertyId(ctx, featureIndicators.projectMeterLand);
};
const checkIfRequiredConstructions = function (ctx: any) {
  return getFromContextTypePropertyId(
    ctx,
    featureIndicators.projectMeterConstruction
  );
};

// Schema definition
export const BuildingUnitSchema = object({
  id: string().label("Id de la unidad").default(""),
  name: string()
    .required("El nombre de la unidad es requerido")
    .default("")
    .label("Nombre"),
  price: string()
    .isNumeric()
    // .isInteger()
    .minValue(1, "Debe ser mayor a 0")
    .required("El precio de la unidad es requerido")
    .default("")
    .label("Precio"),
  currency: array()
    .of(SchemaItemGeneric)
    // .min(1, "El tipo de moneda de la unidad es requerida")
    .default([])
    .label("Moneda"),
  bedrooms: string()
    .isNumeric()
    .isInteger()
    .default("")
    .label("Habitaciones")
    .when([], (type_property, schema, ctx) => {
      if (checkIfRequiredBedroom(ctx)) {
        return schema
          .minValue(1, "Debe ser mayor a 0")
          .required("Las habitaciones de la unidad son requeridas");
      }
      return schema;
    }),
  bathrooms: string()
    .label("Baños")
    .isNumeric()
    .isInteger()
    .default("")
    .when([], (type_property, schema, ctx) => {
      if (checkIfRequiredBathRooms(ctx)) {
        return schema
          .minValue(1, "Debe ser mayor a 0")
          .required("Los Baños de la unidad son requeridos");
      }
      return schema;
    }),
  halfBathrooms: string()
    .label("Medios Baños")
    .isNumeric()
    .isInteger()
    .default("")
    .when([], (type_property, schema, ctx) => {
      return schema.minValue(0, "Debe ser mayor a 0");
    }),
  parkingSpots: string()
    .isNumeric()
    .isInteger()
    .default("")
    .when([], (type_property, schema, ctx) => {
      if (checkIfRequiredBathParking(ctx)) {
        return schema
          .minValue(1, "Debe ser mayor a 0")
          .required("Los parqueos de la unidad son requeridos");
      }
      return schema;
    })
    .label("Parqueos"),
  levelFloor: string()
    .isNumeric()
    .isInteger()
    .when([], (type_property, schema, ctx) => {
      if (checkIfRequiredLevel(ctx)) {
        return schema
          .minValue(1, "Debe ser mayor a 0")
          .required("El nivel de la unidad es requerido");
      }
      return schema;
    })
    .default("")
    .label("Nivel"),
  totalFloor: string().isNumeric().isInteger().default("").label("Total de Niveles"),
  metersConstruction: string()
    .default("")
    .isNumeric()
    .when([], (type_property, schema, ctx) => {
      if (checkIfRequiredConstructions(ctx)) {
        return schema
          .minValue(1, "Debe ser mayor a 0")
          .required("Los metros de construcción de la unidad son requeridos");
      }
      return schema;
    })
    .label("Metros de Construcción"),
  metersLand: string()
    .isNumeric()
    .default("")
    .when([], (type_property, schema, ctx) => {
      if (checkIfRequiredLands(ctx)) {
        return schema
          .minValue(1, "Debe ser mayor a 0")
          .required("Los metros de solar de la unidad son requeridos");
      }
      return schema;
    })
    .label("Metros de solar"),
  isNew: boolean().required().default(true),
  isDelete: boolean().required().default(false),
  maintenanceFee: string().isNumeric().default("").label("Cuota de Mantenimiento"),
  maintenanceCurrency: array()
    .of(SchemaItemGeneric)
    .default([])
    .label("Moneda de Mantenimiento"),
  features: array().default([]).label("Características"),
  totalCommission: string().isNumeric().default("").label("Comisión Total"),
  commissionGuaranteed: string()
    .isNumeric()
    .default("")
    .label("Comisión Garantizada"),
  characteristics_roof_property: array()
    .of(SchemaItemGeneric)
    .default([])
    .label("Techo"),
  characteristics_roof_form_property: array()
    .of(SchemaItemGeneric)
    .default([])
    .label("Forma del Techo"),
  characteristics_frames_property: array()
    .label("Características de marcos")
    .of(SchemaItemGeneric)
    .default([]),
  characteristics_door_property: array()
    .of(SchemaItemGeneric)
    .default([])
    .label("Puertas"),
  characteristics_closets_property: array()
    .of(SchemaItemGeneric)
    .default([])
    .label("Closets"),
  characteristics_windows_property: array()
    .of(SchemaItemGeneric)
    .default([])
    .label("Ventanas"),
  characteristics_cabinets_property: array()
    .of(SchemaItemGeneric)
    .default([])
    .label("Gabinetes"),
  characteristics_floors_property: array()
    .of(SchemaItemGeneric)
    .default([])
    .label("Pisos"),
  characteristics_type_house_property: array()
    .of(SchemaItemGeneric)
    .default([])
    .label("Tipo de Casa")
});

export type IPropertyBuildingUnitForm = InferType<typeof BuildingUnitSchema>;
export const CPropertyBuildingUnitForm = BuildingUnitSchema.getDefault();
export const CPropertyBuildingUnitFormKeys = HGetKeyEnums(
  CPropertyBuildingUnitForm
) as {
  [K in keyof typeof CPropertyBuildingUnitForm]: K;
};
